import React, {useState, useEffect} from "react";
import "./RecoilApp.css";
import Navbar from "./Components/Navbar/Navbar";
import SwitchPage from "./Pages/SwitchPage/SwitchPage";
import {atom, useRecoilValue, useSetRecoilState} from "recoil";
import { authAtom } from '../Connect/_state';
import User from "./Model/User";
import { useUserActions } from "../Connect/_actions";
import { Role } from "./Useful/enum";
import { windowSize } from "./Useful/windowSize";
import cadenas from "./assets/cadenas.png";
import Loc from "../Loc/Loc";

export const userAtom = atom({
    key: 'user',
    default: new User()//default_user
})

export const windowSizeAtom = atom({
    key: 'windowSize',
    default: {width: 0, height: 0}
})

export default function RecoilApp() {
    const userActions = useUserActions();
    const auth = useRecoilValue(authAtom);
    const setUser = useSetRecoilState(userAtom);
    const setWindowSize = useSetRecoilState(windowSizeAtom);
    const [page, setPage] = useState("Home");
    const [isTokenValid, setIsTokenValid] = useState(false);
    const [checkingMessage, setCheckingMessage] = useState(Loc.trad().RecoilAppConnection);
    const [isCheckingToken, setIsCheckingToken] = useState(false);
    const [language, setLanguage] = useState(() => Loc.trad());

    useEffect(() => {
        let user: User = new User();
        if (auth) {
            setUser(auth);
            user = auth;
        }
        setWindowSize(windowSize());
        if (user.role >= Role.PermUser /* si le user est défini */ && !isTokenValid && !isCheckingToken) {
            setIsCheckingToken(true);
            userActions.isTokenValid(user).then(() => setIsTokenValid(true)).catch((e) => setCheckingMessage(e));
        }
    }, [setUser, auth, userActions, isTokenValid, isCheckingToken, setWindowSize])

    const setPageOnClick = (page: string) => {
        setPage(page);
    }

    const noOverflowPages = ["ModifPassword", "MyAccount"];

    function define_overflow(currentPage: string) {
        if (noOverflowPages.indexOf(currentPage) > -1)
            return ("hidden");
        return ("");
    }

    return (
        (isTokenValid ?
            <div style={{ height: "100vh", overflow: define_overflow(page) }}>
                <Navbar page={page} setPageOnClick={setPageOnClick} setLanguage={setLanguage}></Navbar>
                <SwitchPage page={page} setPageOnClick={setPageOnClick}></SwitchPage>
            </div> :
            <div className="checking">
                <img src={cadenas} alt="locker" style={{width: '100px', marginBottom: '20px'}}></img>
                <div>{checkingMessage} {checkingMessage === Loc.trad().RecoilAppConnection && <span className="spinner-border spinner-border-sm mr-1"></span>}</div>
            </div>)
    );
}